// frontend/src/components/TextAreaWithPhrases/TextAreaWithPhrases.js
/**
 * Textarea component with quick phrase autocomplete support
 * Type ; to trigger phrase suggestions
 */
import React, { useRef, useContext } from 'react';
import { UserContext } from '../../UserContext';
import { useQuickPhrases } from '../../hooks/useQuickPhrases';
import QuickPhraseDropdown from '../QuickPhraseDropdown';
import './TextAreaWithPhrases.css';

const TextAreaWithPhrases = ({
  value,
  onChange,
  placeholder,
  rows = 4,
  className = '',
  disabled = false,
  readOnly = false,
  ...props
}) => {
  const { user } = useContext(UserContext);
  const useInternalJournal = user?.clinic?.use_internal_journal || false;
  const textareaRef = useRef(null);

  // Quick phrases hook
  const {
    showDropdown,
    dropdownPosition,
    searchQuery,
    filteredPhrases,
    selectedIndex,
    handleKeyDown: handlePhraseKeyDown,
    handleInput: handlePhraseInput,
    selectPhrase,
    closeDropdown,
    loading: phrasesLoading
  } = useQuickPhrases(textareaRef, (newValue) => {
    onChange({ target: { value: newValue } });
  });

  // Handle input change
  const handleChange = (e) => {
    onChange(e);

    // Trigger phrase autocomplete if internal journal is enabled
    if (useInternalJournal) {
      handlePhraseInput(e);
    }
  };

  // Handle keyboard events
  const handleKeyDown = (e) => {
    // Let quick phrases hook handle navigation keys first
    if (useInternalJournal && showDropdown) {
      const handled = handlePhraseKeyDown(e);
      if (handled) return;
    }
  };

  return (
    <div className="textarea-with-phrases-wrapper">
      <textarea
        ref={textareaRef}
        value={value}
        placeholder={placeholder}
        rows={rows}
        className={`textarea-with-phrases ${className}`}
        disabled={disabled}
        readOnly={readOnly}
        {...props}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />

      {/* Quick Phrase Dropdown */}
      {useInternalJournal && (
        <QuickPhraseDropdown
          show={showDropdown}
          position={dropdownPosition}
          phrases={filteredPhrases}
          selectedIndex={selectedIndex}
          searchQuery={searchQuery}
          onSelect={selectPhrase}
          onClose={closeDropdown}
          loading={phrasesLoading}
        />
      )}
    </div>
  );
};

export default TextAreaWithPhrases;
